/**
 * Copyright: ThoughtSpot Inc. 2021
 * Author: Chandershekhar Lhaniwal (Chandershekhar.luhaniwal@thoughtspot.com)
 *
 * @fileoverview Dialogue Alert for Radiant
 */
import _ from 'lodash';
import React from 'react';
import { ConfirmButton, DismissButton, Modal, ModalType } from '../../modal';
import { Typography } from '../../typography';

export interface DialogueAlertProps {
  /**
   * Boolean describing if the Alert Dialogue modal should be shown or not.
   * @default false
   */
  isOpen?: boolean;

  /**
   * Title for the Alert Dialogue
   */
  title?: string;

  /**
   * Alert description to show in the body
   */
  description?: string;

  /**
   * Primary styled button to be used as a Confirmation button
   */
  primaryButton: ConfirmButton;

  /**
   * Secondary styled button to be used as a Dismiss button
   */
  secondaryButton?: DismissButton;

  /**
   * Any additional class name for alert container
   * @default ''
   */
  className?: string;

  onDismiss?: () => void;
}

export const DialogueAlert: React.FC<DialogueAlertProps> = ({
  isOpen = false,
  title,
  description,
  className = '',
  primaryButton,
  secondaryButton,
  onDismiss = _.noop,
}: DialogueAlertProps) => {
  return (
    <Modal
      title={title}
      variant={ModalType.Alert}
      isOpen={isOpen}
      includesHeader={!!title}
      autoScrollContent={false}
      confirmButton={primaryButton}
      dismissButton={secondaryButton}
      className={className}
      onDismiss={onDismiss}
    >
      {description ? (
        <Typography variant="body-large" noMargin>
          {description}
        </Typography>
      ) : undefined}
    </Modal>
  );
};
